import { XMarkIcon } from '@heroicons/react/24/outline';
import styles from './EditorModal.module.css';

/**
 * Modal for sending a photo to the editor for manual processing.
 *
 * Allows selecting a reason and adding details about why manual editing is needed.
 */
export default function EditorModal({
  isOpen,
  reason,
  reasonDetail,
  sending,
  onReasonChange,
  onReasonDetailChange,
  onSend,
  onClose,
}) {
  if (!isOpen) return null;

  return (
    <div className={styles.backdrop} onClick={onClose}>
      <div className={styles.card} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h4 className={styles.title}>Send to Editor</h4>
          <button className={styles.closeButton} onClick={onClose}>
            <XMarkIcon className="icon" />
          </button>
        </div>
        <div className={styles.body}>
          <p className={styles.description}>
            Copy the original file to the editor folder for manual processing.
          </p>
          <div className={styles.field}>
            <label className={styles.label}>Reason</label>
            <select
              value={reason}
              onChange={(e) => onReasonChange(e.target.value)}
              className={styles.select}
            >
              <option value="crop_unsatisfactory">Crop unsatisfactory</option>
              <option value="complex_edit_needed">Complex edit needed</option>
              <option value="special_request">Special request</option>
              <option value="ai_detection_failed">AI detection failed</option>
              <option value="color_correction">Color correction needed</option>
              <option value="other">Other</option>
            </select>
          </div>
          <div className={styles.field}>
            <label className={styles.label}>Details (optional)</label>
            <textarea
              value={reasonDetail}
              onChange={(e) => onReasonDetailChange(e.target.value)}
              placeholder="Additional details about why this needs manual editing..."
              rows={3}
              className={styles.textarea}
            />
          </div>
        </div>
        <div className={styles.footer}>
          <button className={styles.cancelButton} onClick={onClose}>
            Cancel
          </button>
          <button
            className={styles.sendButton}
            onClick={onSend}
            disabled={sending}
          >
            {sending ? 'Sending...' : 'Send to Editor'}
          </button>
        </div>
      </div>
    </div>
  );
}
